/**
 * @deprecated use `@wener/console/window` instead
 */
export * from '../../window';
